import StyleNameHeader from './StyleNameHeader';
import ExprInput from '../../../ExprInput';
const __script_base__ = {
  name: 'DiyClassName',
  components: {
    StyleNameHeader,
    ExprInput
  },
  props: ['primeClass'],
  data() {
    var _this$primeClass;
    const classNames = ((_this$primeClass = this.primeClass) === null || _this$primeClass === void 0 ? void 0 : _this$primeClass.split(' ')) || [];
    // 排除样式模板挂载的样式名
    const customNames = classNames.filter(item => item.indexOf('uc-public') === -1 && item.indexOf('uc-private') === -1);
    const customNameString = customNames.join(' ');
    return {
      diyClassName: customNameString,
      diyClassNameHelpText: '支持插值表达式'
    };
  },
  methods: {
    resetDiyClass() {
      this.diyClassName = '';
    }
  },
  watch: {
    diyClassName: {
      handler() {
        this.$emit('commit', this.diyClassName);
      }
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("StyleNameHeader", {
    attrs: {
      name: "自定义class",
      "reset-option": {
        resetTip: "class",
        resetCallback: _vm.resetDiyClass
      }
    }
  }, [_c("ExprInput", {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      type: "interopable-string"
    },
    model: {
      value: _vm.diyClassName,
      callback: function ($$v) {
        _vm.diyClassName = $$v;
      },
      expression: "diyClassName"
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/PropPanel/StylePanel/comps/diyClassName.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);